"use client";

import { c as _c } from "react/compiler-runtime";
import { DayPicker } from "react-day-picker";
import { ChevronLeft, ChevronRight } from "../../icons";
import { disabledVariants } from "../../styles";
import { classNames } from "../../utils";
import { buttonVariants } from "../Button";
const CalendarIconLeft = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = classNames("-translate-x-px", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <ChevronLeft className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
const CalendarIconRight = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = classNames("translate-x-px", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <ChevronRight className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export function Calendar(t0) {
  const $ = _c(22);
  let className;
  let onSelect;
  let props;
  let selected;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      showOutsideDays: t1,
      selected,
      onSelect,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = onSelect;
    $[3] = props;
    $[4] = selected;
    $[5] = t1;
  } else {
    className = $[1];
    onSelect = $[2];
    props = $[3];
    selected = $[4];
    t1 = $[5];
  }
  const showOutsideDays = t1 === undefined ? true : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames("flex flex-col space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0");
    t3 = classNames("space-y-4");
    t4 = classNames("relative flex items-center justify-center pt-1");
    t5 = classNames("text-sm font-medium");
    t6 = classNames("flex items-center space-x-1");
    t7 = classNames(buttonVariants({
      variant: "secondary"
    }), "size-7 p-0");
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      months: t2,
      month: t3,
      caption: t4,
      caption_label: t5,
      nav: t6,
      nav_button: t7,
      nav_button_previous: "absolute left-1",
      nav_button_next: "absolute right-1",
      table: classNames("w-full border-collapse space-y-1"),
      head_row: classNames("flex"),
      head_cell: classNames("w-9 rounded-md text-sm font-normal text-text-secondary"),
      row: classNames("mt-2 flex w-full"),
      cell: classNames("relative p-0 text-center font-mono text-sm focus-within:relative focus-within:z-20", "aria-selected:rounded-md aria-selected:bg-text-primary", "[&:has([aria-selected].day-outside)]:bg-bg-additional-1"),
      day: classNames(buttonVariants({
        variant: "ghost"
      }), "size-9 p-0 font-normal", "focus-visible:border focus-visible:border-border-1"),
      day_selected: classNames("!bg-text-primary !font-medium !text-bg-primary hover:!bg-text-primary hover:!text-bg-primary"),
      day_today: classNames("bg-bg-additional-1 !font-medium"),
      day_disabled: disabledVariants({
        disabled: true
      }),
      day_hidden: classNames("invisible")
    };
    t9 = {
      IconLeft: CalendarIconLeft,
      IconRight: CalendarIconRight
    };
    $[12] = t8;
    $[13] = t9;
  } else {
    t8 = $[12];
    t9 = $[13];
  }
  let t10;
  if ($[14] !== onSelect) {
    t10 = date => {
      onSelect?.(date);
    };
    $[14] = onSelect;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== className || $[17] !== props || $[18] !== selected || $[19] !== showOutsideDays || $[20] !== t10) {
    t11 = <DayPicker className={className} classNames={t8} components={t9} mode="single" onSelect={t10} selected={selected} showOutsideDays={showOutsideDays} {...props} />;
    $[16] = className;
    $[17] = props;
    $[18] = selected;
    $[19] = showOutsideDays;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}